import {CircularProgress, Box} from '@mui/material';
import {observer} from "mobx-react";

const GenericCircularLoader = observer(({
                                            value,
                                            variant = 'determinate',
                                            size = 20,
                                            thickness = 6,
                                            trackColor = '#D9D9D9',
                                            indicatorColor = 'var(--classicbutton-normal-color)',
                                            testId
                                        }) => {

    const isIndeterminate = variant === 'indeterminate';

    return (
        <Box position="relative"
             display="inline-flex"
             sx={{
                 width: size,
                 height: size,
                 display: 'flex',
                 alignItems: 'center',
                 justifyContent: 'center',
             }}
            data-testId={testId}
        >

            <CircularProgress
                variant="determinate"
                value={100}
                size={size}
                thickness={thickness}
                sx={{
                    color: trackColor,
                }}
            />

            <CircularProgress
                variant={variant}
                value={isIndeterminate ? undefined : value}
                disableShrink={isIndeterminate}
                size={size}
                thickness={thickness}
                sx={{
                    color: indicatorColor,
                    position: 'absolute',
                    left: 0,
                    ...(isIndeterminate && {
                        [`& .MuiCircularProgress-circle`]: {
                            strokeLinecap: 'round',
                            strokeDasharray: '40px 200px',
                        },
                    }),
                }}
            />
        </Box>
    )
});

export default GenericCircularLoader;